import { computed } from 'vue'

let i18nInstance = null

export function setI18n(i18n) {
    i18nInstance = i18n
}

export function t(key, params = {}, fallback = key) {
    try {
        if (i18nInstance && typeof i18nInstance.t === 'function') {
            return i18nInstance.t(key, params) || fallback
        }
    } catch (error) {
        console.warn('Translation error:', error)
    }
    return fallback
}

export function getI18n() {
    return i18nInstance
}

export function useT(key, params = {}, fallback = key) {
    return computed(() => t(key, params, fallback))
}